import {
    AfterViewInit,
    Component,
    ElementRef,
    Inject,
    OnDestroy,
    OnInit, Optional,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute} from "@angular/router";
import {MAT_DIALOG_DATA, MatDialog} from "@angular/material/dialog";
import {PetTall} from "../../../Models/PetTall";
import {Peticiones} from "../services/Peticiones";
import {Gestiones} from "../services/Gestiones";
import {GestionesPeticiones} from "../../../Models/GestionesPeticiones";
import {GestionesPeticionesComentarios} from "../../../Models/GestionesPeticionesComentarios";
import {PeticionesComponent} from "../peticiones.component";
import {AlertArgumentarioComponent} from "../../VistasGenericas/alert-argumentario/alert-argumentario.component";
import {Observaciones} from "../services/Observaciones";

@Component({
    selector: 'ral-peticiones_detalle',
    templateUrl: './detalle_peticion.component.html',
    styleUrls: ['./detalle_peticion.component.scss']
})

export class DetallePeticionComponent implements OnInit
{
    peticion = ""
    estado: string = "";
    gestion_pet: string = "";
    matricula: string = "";
    dataItems: any[] = [];
    messages: string[][] = [];
    comentarios: string[] = [];
    comentarioInsertar = "";
    gestion: number = 0;
    tipo: string = "";
    coste: number = 0;
    cargaDatos1: boolean = true
    cargaDatos2: boolean = true

    traduccionEstado: { [key: string] : string;  } = {
      "": "Pendiente",
      "A": "Anulado",
      "P": "Preparado",
      "S": "Servido",
      "R": "Reservado",
      "F": "Tramitado",
      "T": "Pendiente Revision",
      "B": "Bloqueo-Pendiente",
      "O": "Servicio Oficial"
    }

    traduccionEstadoFinal: { [key: string] : string;  } = {
      "": "",
      "E": "Reclamado",
      "D": "Devuelto",
      "R": "Recepcionado",
      "C": "Cancelado",
    }
    peticionesComplementarias: string[][] = [];
    displayedColumnsMensajes: string[] = ['mensaje', 'usuario', 'fecha'];
    displayedColumnsComentarios: string[] = ['mensaje'];

    constructor(private http: HttpClient,
                private route: ActivatedRoute,
                public dialog:MatDialog,
                @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
        // Extract the 'peticion' parameter from the route or from the dialog data
        this.route.paramMap.subscribe(params => {
            let peticion: string | null = params.get('peticion');

            if (peticion == null && data != null) {
                peticion = data.peticion;
            }

            if (peticion) {
                this.peticion = peticion!;
            } else {
                console.error("Petición not provided. This component requires either a route parameter or dialog data.");
            }
        });
    }

    ngOnInit(): void {
        this.loadData();

    }

    loadData():void{
      this.cargarDetalle();

      this.cargarComplementarios();

      this.cargarComentarios();

      this.cargarComentariosCompras();
    }

    cargarDetalle(){
        let arrParams =
            {
                matricula: "",
                parameters: {
                    parameters:
                        [
                            [
                                {
                                    campo: PetTall.prefix + ".peticio",
                                    operacion:"=",
                                    valor: this.peticion.toString()
                                }
                            ]
                        ],
                    select:[PetTall.prefix + ".peticio as peticion", PetTall.prefix + ".par_001 as estado", PetTall.prefix + ".par_013 as gestion"]
                }
            };

        Peticiones.getDetallePet(this.http, arrParams).then(
            (res: any)=>
            {
                if (res.length > 0)
                {
                    this.peticion = res[0]["peticion"];
                    this.gestion_pet = this.traduccionEstadoFinal[res[0]["gestion"].toString().trim()];
                    this.estado = this.traduccionEstado[res[0]["estado"].toString().trim()];
                    this.matricula = res[0]["matricula"];
                    this.coste = res[0]["coste"];
                    this.tipo = res[0]["tipo_pedido"];
                    delete res[0]["peticion"];
                    this.dataItems = Object.keys(res[0]).map(key => {
                        return { label: key, value: res[0][key] };
                    });
                }
            }
        ).catch(
            (err: any)=>
            {
              AlertArgumentarioComponent.mostrarArgumentario("Error", ["Ha ocurrido un error inesperado."], true, true, true, this.dialog);
            }
        ).finally(() => {this.cargaDatos1 = false;});
    }

    cargarComplementarios(){
        let arrParams =
            {
                matricula: "",
                parameters: {
                    parameters:
                        [
                            [
                                {
                                    campo: PetTall.prefix + ".peticion_padre",
                                    operacion:"=",
                                    valor: this.peticion.toString()
                                }
                            ]
                        ],
                    select:[PetTall.prefix + ".peticio as peticion", PetTall.prefix + ".par_001 as estado", PetTall.prefix + ".par_013 as gestion_actual", PetTall.prefix + ".par_001 as gestion"]
                }
            };

        Peticiones.getDetallePet(this.http, arrParams).then(
            (res: any)=>
            {
                this.peticionesComplementarias = [];
                if (res.length > 0)
                {
                    for (let i = 0; i < res.length; i++)
                    {
                        this.peticionesComplementarias.push([res[i]["peticion"], res[i]["estado"]]);
                        console.log(this.peticionesComplementarias);
                    }
                }
            }
        ).catch(
            (err: any)=>
            {
              AlertArgumentarioComponent.mostrarArgumentario("Error", ["Ha ocurrido un error inesperado."], true, true, true, this.dialog);
            }
        ).finally(() => {this.cargaDatos2 = false;});
    }

    cargarComentarios(){
        let arrParams =
            {
                parameters:
                    [
                        [
                            {
                                campo: GestionesPeticiones.prefix + ".peticion",
                                operacion:"=",
                                valor: this.peticion.toString()
                            }
                        ],
                        [
                            {
                                campo: GestionesPeticiones.prefix + ".finalizada",
                                operacion:"=",
                                valor: "False"
                            }
                        ]
                    ],
                select:[GestionesPeticiones.prefix + ".id", GestionesPeticionesComentarios.prefix + ".comentario", GestionesPeticionesComentarios.prefix + ".fichero", GestionesPeticionesComentarios.prefix + ".usuario", GestionesPeticionesComentarios.prefix + ".created",  GestionesPeticionesComentarios.prefix + ".gestion"],
                orden: [[GestionesPeticionesComentarios.prefix + ".created", "desc"]]
            };

        Gestiones.getComentarios(this.http, arrParams).then(
            (res: any)=>
            {
                this.messages = [];
                if (res.length > 0)
                {
                    this.gestion = res[0]["id"];
                    for (let i = 0; i < res.length; i++)
                    {
                        //Check if comentario	Object { }
                        if (this.isEmptyObject(res[i]["created"])){
                            continue;
                        }
                        let datePart: string = res[i]["created"].split('T')[0];
                        let [year, month, day] = datePart.split('-');

                        let timePart: string = res[i]["created"].split('T')[1];
                        let [hours, minutes, seconds] = timePart.split(':');
                        let formattedDate: string = `${day}-${month}-${year} ${hours}:${minutes}:${parseInt(seconds)}`;

                        this.messages.push([res[i]["comentario"], res[i]["usuario"], formattedDate]);
                    }
                }

            }
        ).catch(
            (err: any)=>
            {
                if (err.status != 404){
                    //console.log(err);
                  AlertArgumentarioComponent.mostrarArgumentario("Error", ["Ha ocurrido un error inesperado."], true, true, true, this.dialog);
                }

            }
        );
    }

  cargarComentariosCompras(){
    let arrParams =
      {
        parameters:
          [
            [
              {
                campo: "peticion",
                operacion:"=",
                valor: this.peticion.toString()
              }
            ]
          ],
        select:["obsercall"]
      };

    Observaciones.getObservaciones(this.http, arrParams).then(
      (res: any)=>
      {
        this.comentarios = [];
        if (res.length > 0)
        {
          console.log(res[0]);
          if (res[0]["obsercall"]) {
            this.comentarios = res[0]["obsercall"].split('\r\n');
          }
          console.log(this.comentarios);
        }

      }
    ).catch(
      (err: any)=>
      {
        if (err.status != 404){
          //console.log(err);
          AlertArgumentarioComponent.mostrarArgumentario("Error", ["Ha ocurrido un error inesperado."], true, true, true, this.dialog);
        }

      }
    );
  }

    isEmptyObject(value: any): boolean {
        return value !== null && typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0;
    }

    insertarComentario(){
        if (this.comentarioInsertar == "")
        {
            AlertArgumentarioComponent.mostrarArgumentario("Error", ["Debe introducir un comentario."], true, true, true, this.dialog);
            return;
        }

        var gestionComentario = {

            "gestion": this.gestion,
            "comentario": this.comentarioInsertar,
            "usuario": PeticionesComponent.username

        };

        Gestiones.insertComentario(this.http, gestionComentario).then(
            (res: any)=>
            {
              AlertArgumentarioComponent.mostrarArgumentarioRes("OK", ["Se ha insertado correctamente"], true, true, false, this.dialog).subscribe(result => {this.loadData(); this.comentarioInsertar = "";});

            }

        ).catch(
            (err: any)=>
            {
              AlertArgumentarioComponent.mostrarArgumentario("Error", [err.message], true, true, true, this.dialog);
            }
        );
    }


}
